<template>
    <!--    max-width="600px"-->
    <v-dialog v-model="$props.params.supportDialog" transition="dialog-bottom-transition"
              @keydown.esc="closeSupportDialog()" @click:outside="closeSupportDialog()" fullscreen scrollable>

        <v-form ref="form" v-model="formModel">

            <v-card>
                <v-toolbar color="primary" dark :class="dialogHeadingClasses()" class="pt-0i border-radius-0i">
                    <v-icon v-text="icons.mdiHelpCircleOutline" class="mr-3"></v-icon>
                    <span class="text-truncate" v-text="$gettext('Where? & Why?')"></span>
                    <v-spacer></v-spacer>
                    <v-icon class="mr-2" @click.native.stop="closeSupportDialog()" v-text="icons.mdiClose"></v-icon>
                    <v-icon @click.native.stop="processWhere()" v-text="icons.mdiContentSave"></v-icon>
                </v-toolbar>

                <v-divider></v-divider>

                <v-card-text class="mt-8 fill-height">
                    <v-container>
                        <v-row>
                            <v-col cols="12">

                                <!-- Have tabs for where module and why module -->

                                <v-tabs>
                                    <v-tab v-text="$gettext('Where?')"></v-tab>
                                    <v-tab v-text="$gettext('Why?')"></v-tab>
                                    <v-tab-item>
                                        <v-card flat>
                                            <v-card-text>
                                                <v-row class="my-3">
                                                    <v-col cols="12">
                                                        <div class="text-h6"
                                                             v-text="$gettext('Locate across the system')"></div>
                                                        <div class="text-body-1"
                                                             v-text="$gettext('The where module will help you find, details such as mac address, domain, or MDM credentials across the entire portal')"></div>
                                                    </v-col>
                                                </v-row>

                                                <v-row>
                                                    <v-col>
                                                        <v-text-field :label="$gettext('Locate across the system')"
                                                                      :placeholder="$gettext('Search for mac address, domain, or MDM credentials')"
                                                                      required
                                                                      v-model="query" outlined
                                                                      @input="debounceProcessWhere()"
                                                                      autofocus
                                                                      clearable>
                                                        </v-text-field>
                                                    </v-col>
                                                </v-row>

                                                <v-divider class="mb-6"
                                                           v-if="sources.length > 0 && query.length > 0"></v-divider>

                                                <v-row v-if="sources.length > 0 && query.length > 0">
                                                    <v-col>
                                                        <!--                                show-group-by-->
                                                        <!--                                                        loading-->
                                                        <v-data-table :headers="headers" hide-default-header
                                                                      :items="sources" :search="query"
                                                                      class="elevation-1" group-by="entity"
                                                                      hide-default-footer
                                                                      disable-pagination
                                                                      :loading="whyInProgress"
                                                                      :loading-text="$gettext('Loading...')"
                                                        >
                                                            <!--                                    <template v-slot:item.attribute="{ item }">
                                                                                                    {{ getAttributeTextByKey(item.attribute) }}
                                                                                                </template>-->

                                                            <!------------------------------------------------
                                                                Headers
                                                            ------------------------------------------------->

                                                            <template v-slot:group.header="{ items, isOpen, toggle }">
                                                                <th colspan="2" class="py-4 cursor-pointer"
                                                                    @click="toggle">
                                                                    <v-icon class="mr-2">
                                                                        {{ isOpen ? 'mdi-minus' : 'mdi-plus' }}
                                                                    </v-icon>
                                                                    <span
                                                                        :class="{ 'text-h6': isOpen, 'subtitle-1': !isOpen }"
                                                                        class="font-weight-light">{{
                                                                            getEntitySingularTextByKey(items[0].entity)
                                                                        }}</span>
                                                                    <span v-if="items[0].intermediate_entity">

                                                <span :class="{ 'text-h6': isOpen, 'subtitle-1': !isOpen }"
                                                      class="font-weight-light"> / {{
                                                        getEntitySingularTextByKey(items[0].intermediate_entity)
                                                    }}</span>
                                            </span>
                                                                    <span v-if="items[0].intermediate_entity2">
                                                <span :class="{ 'text-h6': isOpen, 'subtitle-1': !isOpen }"
                                                      class="font-weight-light"> / {{
                                                        getEntitySingularTextByKey(items[0].intermediate_entity2)
                                                    }}</span>
                                            </span>
                                                                    <span v-if="items[0].attribute">
                                                <span :class="{ 'text-h6': isOpen, 'subtitle-1': !isOpen }"
                                                      class="font-weight-light"> /
                                                    {{ getAttributeTextByKey(items[0].attribute) }}
                                                </span>
                                            </span>
                                                                </th>
                                                            </template>

                                                            <!------------------------------------------------
                                                                Rows
                                                            ------------------------------------------------->

                                                            <template v-slot:item.value="{ item }">

                                                                <div
                                                                    :class="{'pa-5 subtitle-1': $vuetify.breakpoint.mdAndUp, 'body-2 py-3 text-left': $vuetify.breakpoint.smAndDown}">

                                                                    <!------------------------------------------------
                                                                        Entity
                                                                    ------------------------------------------------->

                                                                    <v-icon class="mr-1"
                                                                            v-text="getEntityIconByKey(item.entity)"></v-icon>
                                                                    {{ getEntitySingularTextByKey(item.entity) }}: {{
                                                                        item.entity_row_name
                                                                    }}

                                                                    <!------------------------------------------------
                                                                        Slash seperator
                                                                    ------------------------------------------------->

                                                                    <v-icon class="mr-1" v-text="icons.mdiSlashForward"
                                                                            v-if="item.intermediate_entity && $vuetify.breakpoint.mdAndUp"></v-icon>
                                                                    <div v-if="$vuetify.breakpoint.smAndDown"
                                                                         class="my-1"/>

                                                                    <!------------------------------------------------
                                                                        Intermediate Entity
                                                                    ------------------------------------------------->

                                                                    <v-icon class="mr-1"
                                                                            v-text="getEntityIconByKey(item.intermediate_entity)"
                                                                            v-if="item.intermediate_entity"></v-icon>

                                                                    <span v-if="item.intermediate_entity">
                                                {{
                                                                            getEntitySingularTextByKey(item.intermediate_entity)
                                                                        }}: {{
                                                                            item.intermediate_entity_row_name
                                                                        }}
                                            </span>

                                                                    <!------------------------------------------------
                                                                        Slash seperator
                                                                    ------------------------------------------------->

                                                                    <v-icon class="mr-1" v-text="icons.mdiSlashForward"
                                                                            v-if="item.intermediate_entity2 && $vuetify.breakpoint.mdAndUp"></v-icon>
                                                                    <div v-if="$vuetify.breakpoint.smAndDown"
                                                                         class="my-1"/>

                                                                    <!------------------------------------------------
                                                                        Intermediate Entity 2
                                                                    ------------------------------------------------->

                                                                    <span v-if="item.intermediate_entity2">
                                                <v-icon class="mr-1"
                                                        v-text="getEntityIconByKey(item.intermediate_entity2)"></v-icon>
                                                {{ getEntitySingularTextByKey(item.intermediate_entity2) }}: {{
                                                                            item.intermediate_entity_row_name2
                                                                        }}
                                            </span>

                                                                    <!------------------------------------------------
                                                                        Slash seperator
                                                                    ------------------------------------------------->

                                                                    <v-icon class="mr-1" v-text="icons.mdiSlashForward"
                                                                            v-if="$vuetify.breakpoint.mdAndUp"></v-icon>
                                                                    <div v-if="$vuetify.breakpoint.smAndDown"
                                                                         class="my-1"/>

                                                                    <!------------------------------------------------
                                                                        Attribute
                                                                    ------------------------------------------------->

                                                                    <v-icon class="mr-1"
                                                                            v-text="getAttributeIconByKey(item.attribute)"></v-icon>
                                                                    {{ getAttributeTextByKey(item.attribute) }}:
                                                                    <span
                                                                        :inner-html.prop="item.value | highlight(query, isDark)"></span>

                                                                </div>

                                                            </template>
                                                        </v-data-table>
                                                    </v-col>
                                                </v-row>
                                                <v-row v-else-if="query.length > 0">
                                                    <v-col>
                                                        <div class="text-center">
                                                            <v-icon size="100"
                                                                    v-text="icons.mdiEmoticonSadOutline"></v-icon>
                                                            <div class="text-h6 mt-3"
                                                                 v-text="$gettext('No results found.')"></div>
                                                        </div>
                                                    </v-col>
                                                </v-row>


                                            </v-card-text>
                                        </v-card>
                                    </v-tab-item>
                                    <v-tab-item>
                                        <v-card flat>
                                            <v-card-text>
                                                <!--                                                slide up transition when gone -->
                                                <v-slide-y-transition>
                                                    <v-row class="my-3" v-if="!whyResponse.length && !whyCurrentUser">
                                                        <v-col cols="12">
                                                            <div class="text-h6"
                                                                 v-text="$gettext('Check the access')"></div>
                                                            <div class="text-body-1"
                                                                 v-text="$gettext('See whether a user has access to a domain or not')"></div>
                                                        </v-col>
                                                    </v-row>
                                                </v-slide-y-transition>
                                                <v-slide-y-transition>
                                                    <v-row v-if="!whyCurrentUser">
                                                        <v-col cols="12" lg="6">

                                                            <!-- domain field-->
                                                            <v-text-field
                                                                v-model="website"
                                                                :label="$gettext('Website')"
                                                                :placeholder="$gettext('Enter website')"
                                                                required
                                                                outlined
                                                                :rules="[v => !!v || 'Website is required']"
                                                                autofocus
                                                                clearable
                                                                :disabled="whyInProgress"
                                                            ></v-text-field>
                                                        </v-col>
                                                        <v-col cols="12" lg="6">
                                                            <!-- consolidated users and subusers dropdown, single select -->
                                                            <v-autocomplete
                                                                v-model="user"
                                                                :label="$gettext('User')"
                                                                :placeholder="$gettext('Select user')"
                                                                :items="consolidatedUsersAndSubUsers"
                                                                item-text="key"
                                                                item-value="key"
                                                                outlined
                                                                :rules="[v => !!v || 'Website is required']"
                                                                required
                                                                clearable
                                                                :disabled="whyInProgress"
                                                            ></v-autocomplete>

                                                        </v-col>
                                                    </v-row>
                                                </v-slide-y-transition>
                                                <v-row v-if="!whyResponse.length">
                                                    <v-col>
                                                        <v-btn class="primary" @click="processWhy()"
                                                               :disabled="whyInProgress"
                                                               :class="{'mt-4': whyInProgress}">

                                                            <span v-if="whyInProgress">
                                                            <v-progress-circular
                                                                :size="16"
                                                                width="2"
                                                                class="mr-2"
                                                                color="primary"
                                                                indeterminate
                                                            ></v-progress-circular>
                                                            </span>

                                                            <span v-if="whyInProgress">{{
                                                                    $gettext('Checking...')
                                                                }}</span>
                                                            <span v-else>{{ $gettext('Check Access') }}</span>
                                                        </v-btn>
                                                    </v-col>
                                                </v-row>

                                                <v-row v-if="whyResponse.length > 0" class="text-h5">
                                                    <v-col>

                                                        <div v-if="whyFinalResult()" class="green--text mt-4">
                                                            <v-icon v-text="icons.mdiEmoticonHappyOutline"
                                                                    class="green--text" large></v-icon>
                                                            {{
                                                                $gettextInterpolate($gettext('%{ website } is allowed for %{ user }'), {
                                                                    website: whyCurrentWebsite,
                                                                    user: whyCurrentUser
                                                                })
                                                            }}
                                                        </div>
                                                        <div v-else class="red--text mt-4">
                                                            <!--                                                            <v-icon v-text="icons.mdiEmoticonSadOutline" class="red&#45;&#45;text d-block mx-auto mb-3" size="80"></v-icon>
                                                                                                                        {{
                                                                                                                            $gettextInterpolate($gettext('%{ website } is not accessible by %{ user }'), {
                                                                                                                                website: whyCurrentWebsite,
                                                                                                                                user: whyCurrentUser
                                                                                                                            })
                                                                                                                        }}-->

                                                            <v-icon v-text="icons.mdiEmoticonSadOutline"
                                                                    class="red--text" large></v-icon>
                                                            {{
                                                                $gettextInterpolate($gettext('%{ website } is not allowed for %{ user }'), {
                                                                    website: whyCurrentWebsite,
                                                                    user: whyCurrentUser
                                                                })
                                                            }}
                                                        </div>

                                                    </v-col>
                                                </v-row>
                                                <v-row
                                                    v-if="whyCurrentWebsite.length > 0 && !whyInProgress && whyResponse.length > 0"
                                                    class="subtitle-2 d-flex">
                                                    <v-col cols="12" md="6">{{
                                                            $gettextInterpolate($gettext('Sequential rule results for %{ website } and %{ user }'), {
                                                                website: whyCurrentWebsite,
                                                                user: whyCurrentUser
                                                            })
                                                        }}
                                                        <v-icon v-text="icons.mdiInformationOutline"
                                                                :title="$gettext('Hover over the icons in the below table to know more')"/>
                                                    </v-col>
                                                    <v-col class="text-right" cols="12" md="6">
                                                        <v-icon v-text="icons.mdiRefresh" class="mr-2 text--primary"/>
                                                        <a @click="resetWhy">{{ $gettext('Check Again') }}</a>
                                                    </v-col>
                                                </v-row>
                                                <!--<v-row v-if="whyResponse.length > 0 && !whyInProgress">
                                                    <v-col>
                                                        <v-alert type="info" dismissible dense color="grey">
                                                            {{ $gettext('Hover over the icons to know more') }}
                                                        </v-alert>
                                                    </v-col>
                                                </v-row>-->
                                                <v-row
                                                    v-if="!whyInProgress && whyCurrentWebsite && whyResponse.length > 0">
                                                    <v-col>
                                                        <!--                                                        v-data-table for whyResponse-->
                                                        <v-slide-y-transition>
                                                            <v-data-table :headers="whyHeaders"
                                                                          :items="whyResponse"
                                                                          class="elevation-1"
                                                                          hide-default-footer
                                                                          disable-pagination>

                                                                <template v-slot:item.rule="{ item, index }">
                                                                    <span class="mr-2">{{ index + 1 }}.</span> {{
                                                                        item.rule
                                                                    }}
                                                                </template>

                                                                <template v-slot:item.user="{ item }">

                                                                    <v-icon color="green" v-if="item.user === 1"
                                                                            v-text="icons.mdiEmoticonExcited"
                                                                            :title="$gettextInterpolate($gettext('%{ rule } is applied, and it allows the connection'), { rule: item.rule })"></v-icon>
                                                                    <v-icon color="red" v-else
                                                                            v-text="icons.mdiEmoticonSadOutline"
                                                                            :title="$gettextInterpolate($gettext('%{ rule } is applied, and it blocks the connection'), { rule: item.rule })"></v-icon>
                                                                </template>

                                                                <template v-slot:item.time="{ item }">
                                                                    <v-icon color="green" v-if="item.time === 1"
                                                                            v-text="icons.mdiClockOutline"
                                                                            :title="$gettextInterpolate($gettext('%{ rule } is applied, and it allows the connection'), { rule: item.rule })"></v-icon>
                                                                    <v-icon color="red" v-if="item.time === 0"
                                                                            v-text="icons.mdiClockOutline"
                                                                            :title="$gettextInterpolate($gettext('%{ rule } is applied, and it blocks the connection'), { rule: item.rule })"
                                                                    ></v-icon>
                                                                </template>
                                                                <template v-slot:item.domain="{ item }">
                                                                    <v-icon color="green" v-if="item.domain === 1"
                                                                            v-text="icons.mdiWeb"
                                                                            :title="$gettextInterpolate($gettext('%{ rule } is applied, and it allows the connection'), { rule: item.rule })"></v-icon>
                                                                    <v-icon color="red" v-else-if="item.domain === 0"
                                                                            :title="$gettextInterpolate($gettext('%{ rule } is applied, and it blocks the connection'), { rule: item.rule })"
                                                                            v-text="icons.mdiWeb"></v-icon>
                                                                </template>
                                                                <template v-slot:item.cat="{ item }">
                                                                    <v-icon color="green" v-if="item.cat === 1"
                                                                            v-text="icons.mdiBookOpenBlankVariant"
                                                                            :title="$gettextInterpolate($gettext('%{ rule } is applied, and it allows the connection'), { rule: item.rule })"
                                                                    ></v-icon>
                                                                    <v-icon color="red" v-else-if="item.cat === 0"
                                                                            :title="$gettextInterpolate($gettext('%{ rule } is applied, and it blocks the connection'), { rule: item.rule })"
                                                                            v-text="icons.mdiBookOpenBlankVariant"></v-icon>
                                                                </template>
                                                                <template v-slot:item.action="{ item }">
                                                                    <v-icon color="green" v-if="item.action === 1"
                                                                            v-text="icons.mdiCheckCircle"
                                                                            :title="$gettextInterpolate($gettext('%{ rule } is applied, and it is allowed'), { rule: item.rule })"></v-icon>
                                                                    <v-icon color="red" v-else-if="item.action === 0"
                                                                            v-text="icons.mdiCloseCircle"
                                                                            :title="$gettextInterpolate($gettext('%{ rule } is not applied, and it is not allowed'), { rule: item.rule })"></v-icon>
                                                                </template>
                                                            </v-data-table>
                                                        </v-slide-y-transition>
                                                    </v-col>
                                                </v-row>

                                                <v-row
                                                    v-if="whyCurrentUser && !whyInProgress && whyResponse.length > 0">
                                                    <v-col class="text-center">
                                                        <v-btn class="btn btn-primary primary" rounded
                                                               @click="resetWhy()" elevation="3">
                                                            <v-icon v-text="icons.mdiRefresh" class="mr-2"/>
                                                            {{ $gettext('Check Again') }}
                                                        </v-btn>
                                                    </v-col>
                                                </v-row>

                                            </v-card-text>
                                        </v-card>
                                    </v-tab-item>
                                </v-tabs>


                            </v-col>
                        </v-row>


                    </v-container>
                </v-card-text>
                <!--                <v-divider></v-divider>-->

                <!--                <v-card-actions color="secondary">
                                    <v-spacer></v-spacer>
                                    <v-btn class="primary" @click.native.stop="closeSupportDialog()">
                                        {{ $gettext('Close') }}
                                    </v-btn>
                                    <v-btn class="primary" type="submit">
                                        {{ $gettext('Save') }}
                                    </v-btn>
                                </v-card-actions>-->
            </v-card>
        </v-form>
        <snackbar ref="snackbar"></snackbar>
    </v-dialog>
</template>
<style type="text/scss">
.add-rule-radio-margin .v-input--selection-controls {
    margin-top: 0;
}

.border-radius-0i {
    border-radius: 0 !important;
}

.pt-0i {
    padding-top: 0 !important;
}
</style>

<script>

import Vue from 'vue'
import {debounce, find, findIndex, isArray, size} from 'lodash'

import Vuelidate from 'vuelidate'
import {required, minLength, maxLength, between} from 'vuelidate/lib/validators'

import MixinDialog from '@/mixins/MixinDialog'
import MixinIcon from '@/mixins/MixinIcon'
import Snackbar from '@/components/Snackbar'
import MixinStringManipulation from '@/mixins/MixinStringManipulation'
import MixinConfigUsers from '@/mixins/database/MixinConfigUsers'
import MixinVuelidate from '@/mixins/MixinVuelidate'
import {mapState, mapWritableState} from "pinia";
import {useGroupsStore} from "@/stores/GroupsStore";
import {useRulesStore} from "@/stores/RulesStore";
import {useUsersStore} from "@/stores/UsersStore";
import MixinDark from "@/mixins/database/MixinDark";
import axios from "axios";
import {useConnectionsStore} from "@/stores/ConnectionsStore";

Vue.use(Vuelidate)

export default {
    components: {Snackbar},
    mixins: [MixinDialog, MixinIcon, MixinStringManipulation, MixinConfigUsers, MixinVuelidate, MixinDark],
    props: {
        params: {
            required: true,
            type: Object,
        },
    },
    filters: {

        highlight: function (value, query, isDark) {

            // handle if query is empty
            if (!query) return value;

            try {

                let val;

                // Issue: not working with * in the query.
                if (isDark) {
                    val = value.replace(new RegExp(query, "ig"), '<span class=\'grey darken-3 py-2 rounded\'>' + query + '</span>')
                } else {
                    val = value.replace(new RegExp(query, "ig"), '<span class=\'grey lighten-3 py-2 rounded\'>' + query + '</span>')
                }

                return val;

            } catch (e) {
                console.log(e)
                return value;
            }

        }

    },
    mounted() {

        let self = this
        // self.setAllTheDomains()

    },
    data() {
        return {

            formModel: '',

            query: '',
            website: '',
            user: '',
            sources: [],
            headers: [
                /*{
                    text: this.$gettext('Attribute'),
                    align: 'start',
                    sortable: false,
                    value: 'attribute',
                },*/

                {
                    text: this.$gettext('Entity'),
                    align: 'start',
                    sortable: false,
                    value: 'entity',
                },
                /*{
                    text: this.$gettext('Entity Name'),
                    align: 'start',
                    sortable: false,
                    value: 'entity_name',
                },*/
                {
                    text: this.$gettext('Matches'),
                    align: 'start',
                    sortable: false,
                    value: 'value',
                },
                /*{
                    text: this.$gettext('Entity Value'),
                    align: 'start',
                    sortable: false,
                    value: 'entity_value',
                },*/
                /*{
                    text: this.$gettext('Intermediate Entity'),
                    align: 'start',
                    sortable: false,
                    value: 'intermediate_entity',
                },
                {
                    text: this.$gettext('Intermediate Key'),
                    align: 'start',
                    sortable: false,
                    value: 'intermediate_key',
                },*/
                /*{
                    text: this.$gettext('Intermediate Value'),
                    align: 'start',
                    sortable: false,
                    value: 'intermediate_value',
                },*/

            ],
            attributes: [
                {
                    'key': 'sub_user_name',
                    'text': 'Sub User Name',
                    'icon': 'mdi-account-outline',
                },
                {
                    'key': 'domain',
                    'text': 'Domain',
                    'icon': 'mdi-web',
                },
                {
                    'key': 'user',
                    'text': 'User',
                    'icon': 'mdi-account-outline',
                },
                {
                    'key': 'macAddress',
                    'text': 'Mac Address',
                    'icon': 'mdi-lan',
                },
                {
                    'key': 'mdmAccount',
                    'text': 'MDM Account',
                    'icon': 'mdi-key-outline'
                },
                {
                    'key': 'mdmPassword',
                    'text': 'MDM Password',
                    'icon': 'mdi-key-outline'
                },
                {
                    'key': 'user_name',
                    'text': 'User Name',
                    'icon': 'mdi-account-outline',
                },
            ],

            entities: [
                {
                    'key': 'rules',
                    'text': 'Rules',
                    'singularText': 'Rule',
                    'icon': 'mdi-shield-check-outline',
                },
                {
                    'key': 'groups',
                    'text': 'Groups',
                    'singularText': 'Group',
                    'icon': 'mdi-select-group',
                },
                {
                    'key': 'users',
                    'text': 'Users',
                    'singularText': 'User',
                    'icon': 'mdi-account',
                },
                {
                    'key': 'user_category',
                    'text': 'User Category',
                    'singularText': 'User Category',
                    'icon': 'mdi-account-group',
                },
                {
                    'key': 'devices',
                    'text': 'Devices',
                    'singularText': 'Device',
                    'icon': 'mdi-tablet-cellphone',
                },
                {
                    'key': 'mdmCredentials',
                    'text': 'MDM Credentials',
                    'singularText': 'MDM Credential',
                    'icon': 'mdi-key',
                },
                {
                    'key': 'groups_folder',
                    'text': 'Groups Folder',
                    'singularText': 'Groups Folder',
                    'icon': 'mdi-folder',
                },
            ],

            whyHeaders: [
                {
                    text: this.$gettext('Rule'),
                    align: 'start',
                    sortable: false,
                    value: 'rule',
                },
                {
                    text: this.$gettext('User'),
                    align: 'start',
                    sortable: false,
                    value: 'user',
                },
                {
                    text: this.$gettext('Time'),
                    align: 'start',
                    sortable: false,
                    value: 'time',
                },
                {
                    text: this.$gettext('Domain'),
                    align: 'start',
                    sortable: false,
                    value: 'domain',
                },
                {
                    text: this.$gettext('Category'),
                    align: 'start',
                    sortable: false,
                    value: 'cat',
                },
                {
                    text: this.$gettext('Action'),
                    align: 'start',
                    sortable: false,
                    value: 'action',
                },
            ],
            whyResponse: [],
            whyInProgress: false,
            whyCurrentWebsite: '',
            whyCurrentUser: '',

            allDomains: [],
        }
    },

    methods: {

        setAllTheDomains() {

            let self = this;
            let allDomains = [];

            const insertIntoAllDomains = (domains) => {

                domains = typeof domains === 'string' ? JSON.parse(domains) : domains;

                if (typeof allDomains === 'object') {
                    domains.forEach((d) => allDomains.push(d))
                }

            }

            self.rules.forEach((r) => insertIntoAllDomains(r.value.dest_domains))
            self.groups.forEach((g) => insertIntoAllDomains(g.value.dest_domains))

            self.allDomains = allDomains;

        },

        resetWhy() {

            let self = this;
            self.whyCurrentUser = '';
            self.whyCurrentWebsite = '';
            self.website = '';
            self.user = '';
            self.whyResponse = [];
        },

        whyFinalResult() {

            let self = this;

            if (self.whyResponse?.length > 0) {
                let lastRow = self.whyResponse.slice(-1);
                if (lastRow[0].action === 1) {
                    return true;
                }
            }

            return false;

        },

        async processWhy() {

            let self = this;

            if (this.$refs.form.validate()) {

                self.whyInProgress = true;
                self.whyCurrentUser = JSON.parse(JSON.stringify(self.user));
                self.whyCurrentWebsite = JSON.parse(JSON.stringify(self.website));

                let params = {
                    action: 'why',
                    website: self.website,
                    user: self.user,
                    currentConnection: useConnectionsStore().getCurrentConnection()
                };

                try {

                    let whyResponse = await axios.get('support.php', {params});
                    if (whyResponse?.data?.status && whyResponse?.data?.data) {

                        let why = whyResponse.data.data.why;

                        if (why) {
                            self.whyResponse = typeof why === 'string' ? JSON.parse(why) : why;
                        } else {
                            self.whyResponse = []
                            self.$refs.snackbar.showSnackbar(self.$gettext('No results found.'), 'error')
                            self.resetWhy();
                        }

                    } else {
                        return false
                    }

                } catch (error) {

                    // TODO: Log error
                    console.log(error)
                    self.$refs.snackbar.showSnackbar(self.$gettext('Something went wrong. Please try again.'), 'error')
                    return false

                } finally {
                    self.whyInProgress = false;
                    // self.website = '';
                    // self.user = '';

                    // reset
                    // self.$refs.form.reset()

                }

            } else {
                // FIXME: REMOVE THIS
                console.log('in else');
            }


        },

        getAttributeIconByKey(key) {

            let self = this;
            let attribute = self.attributes.filter(a => a.key === key);

            if (attribute && attribute.length > 0) {
                return attribute[0]['icon']
            }

            return ''

        },

        debounceProcessWhere: debounce(function () {
            this.processWhere()
        }, 500),


        getEntityIconByKey(key) {

            let self = this;
            let entities = self.entities.filter(a => a.key === key);

            if (entities && entities.length > 0) {
                return entities[0]['icon']
            }

            return ''

        },

        getAttributeTextByKey(key) {

            let self = this;
            let attribute = self.attributes.filter(a => a.key === key);

            if (attribute && attribute.length > 0) {
                return attribute[0]['text']
            }

        },

        getEntityTextByKey(key) {

            let self = this;
            let entities = self.entities.filter(a => a.key === key);

            if (entities && entities.length > 0) {
                return entities[0]['text']
            }

            return ''

        },

        getEntitySingularTextByKey(key) {

            let self = this;
            let entities = self.entities.filter(a => a.key === key);

            if (entities && entities.length > 0) {
                return entities[0]['singularText']
            }

            return ''

        },

        capitalize(text) {
            return this.$options.filters.capitalize(text)
        },

        /**
         * We need to find matching or partially entries for users, mac addresses, domains, rules, domains, groups, mdm credentials.
         *
         * domains can be found in rules or in groups.
         * Example. Look for “wikipe” would find :
         * rules - John
         * rules - General permissions
         * group - wikipedia,org
         * group - literature
         * As a second step, It would be good to add the groups in rules. Example , if Paul has the group literature, it would create this entry in the list :
         * rules - Paul - group literature
         * entering ab:22 would return :
         * user - Peter - Tablet WiFi
         * Entering LABO_ (partial name of the MDM account) would return :
         * user - Hector - Galaxy S8
         *
         * @param query
         */
        processWhere() {

            let self = this;
            self.sources = [];

            /**
             *
             * We are not using row values as of now but it's kept here for possible future use.
             *
             * @param attribute The matching attribute.
             * @param attributeValue
             * @param entity The entity should be the top most entity in the hierarchy
             * @param entityRowName
             * @param entityRowValue
             * @param intermediateEntity This should be the child entity
             * @param intermediateRowName
             * @param intermediateRowValue
             * @param intermediateEntity2
             * @param intermediateRowName2
             * @param intermediateRowValue2
             */
            function insertSource(attribute, attributeValue, entity, entityRowName, entityRowValue, intermediateEntity = false, intermediateRowName = false, intermediateRowValue = false, intermediateEntity2 = false, intermediateRowName2 = false, intermediateRowValue2 = false) {

                let item = {
                    'attribute': attribute,
                    'value': attributeValue,
                    'entity': entity,
                    'entity_row_name': entityRowName,
                    'entity_row_value': entityRowValue,
                    'intermediate_entity': intermediateEntity,
                    'intermediate_entity_row_name': intermediateRowName,
                    'intermediate_entity_row_value': intermediateRowValue,
                    // not in use as of now but kept for future use.
                    'intermediate_entity2': intermediateEntity2,
                    'intermediate_entity_row_name2': intermediateRowName2,
                    'intermediate_entity_row_value2': intermediateRowValue2,
                };

                self.sources.push(item)

            }

            // listing down the entities involved:

            // 1. Rules -> domain.
            // 2. Rules -> Groups -> domain.
            // 3. User groups -> Users -> devices -> mac address.
            // 4. User groups -> Users -> smartphone devices -> mdm credentials -> mdm account name. Q. Clarify that we will be matching with the password as well.
            // 5. User groups -> User -> name
            // 6. User groups -> User -> sub users -> name
            // 7. Groups -> domain


            // Do not just return the results, also give a reason for the match.
            // There's a searched attributes viz. domains, user name, mac addresses. use v-chip's toggle.

            // Build the source first, and then we run query across all sources and return the results.

            // 1. Rules -> domain.

            if (self.rules.length > 0) {


                self.rules.forEach((rule) => {

                    // 1. Rules -> domain.
                    let rVDomainArray = rule.value.dest_domains;

                    rVDomainArray.forEach((domain) => {

                        if (domain.toLowerCase().includes(self.query.toLowerCase())) {
                            insertSource('domain', domain, 'rules', rule.key, rule.value)
                        }

                    })

                    // 2. Rules -> Groups -> domain.
                    if (rule.value.dest_groups && rule.value.dest_groups.length > 0) {

                        rule.value.dest_groups.forEach((group) => {

                            self.groups.filter(g => g.key === group).forEach((groupRow) => {

                                let gVDomain = groupRow.value.dest_domains;
                                if (typeof gVDomain === 'string') {
                                    gVDomain = JSON.parse(gVDomain)
                                }

                                if (gVDomain.length > 0) {

                                    gVDomain.forEach((domain) => {

                                        if (domain.toLowerCase().includes(self.query.toLowerCase())) {

                                            insertSource('domain', domain, 'rules', rule.key, rule.value, 'groups', groupRow.key, groupRow.value)

                                        }

                                    })


                                }


                            })

                        })

                    }

                })

            }

            // 3. User groups -> Users -> devices -> mac address.

            if (self.users.length > 0) {


                self.users.forEach((userGroup) => {

                    userGroup.value.forEach((user) => {

                        if (user.value.devices && user.value.devices.length > 0) {

                            user.value.devices.forEach((device) => {

                                if (device?.value?.mac?.toLowerCase().includes(self.query.toLowerCase())) {

                                    insertSource('macAddress', device.value.mac, 'user_category', userGroup.key, userGroup.value, 'users', user.key, user.value, 'devices', device.key, device.value)

                                }

                                // 4. User groups -> Users -> smartphone devices -> mdm credentials -> mdm account name.
                                if (device.value.hasOwnProperty('phone') && typeof device.value.phone === 'object') {

                                    let devicePhone = device.value.phone;

                                    if (devicePhone.account && devicePhone.account.toLowerCase().includes(self.query.toLowerCase())) {

                                        insertSource('mdmAccount', devicePhone.account, 'user_category', userGroup.key, userGroup.value, 'users', user.key, user.value, 'devices', device.key, device.value, 'mdmCredentials', 'mdmCredentials', devicePhone)

                                    }

                                    if (devicePhone.password && devicePhone.password.toLowerCase().includes(self.query.toLowerCase())) {

                                        insertSource('mdmPassword', devicePhone.password, 'user_category', userGroup.key, userGroup.value, 'users', user.key, user.value, 'devices', device.key, device.value, 'mdmCredentials', 'mdmCredentials', devicePhone)

                                    }

                                }

                            })

                        }

                        // 5. User groups -> User -> name because this can already be done in the users module. Otherwise this works.
                        /*if (user.key && user.key.toLowerCase().includes(self.query.toLowerCase())) {
                            insertSource('user_name', user.key, 'user_category', userGroup.key, userGroup.value, 'users', user.key, user.value)
                        }*/

                        // 6. User groups -> User -> sub users -> name because this can already be done in the users module. Otherwise this works.
                        /*if (user.value.hasOwnProperty('sub_users') && typeof user.value.sub_users === 'object') {

                            let subUsers = user.value.sub_users;

                            Object.keys(subUsers).forEach((subUserKey) => {

                                let subUser = subUsers[subUserKey];

                                if (subUser.key && subUser.key.toLowerCase().includes(self.query.toLowerCase())) {
                                    insertSource('sub_user_name', subUser.key, 'user_category', userGroup.key, userGroup.value, 'users', user.key, user.value)
                                }

                            })

                        }*/
                    })

                })

            }


            // 7. Groups -> domain

            if (self.groups.length > 0) {


                self.groups.forEach((group) => {

                    // consider that a group can be a folder or a group.
                    if (group.hasOwnProperty('child')) {

                        group.child.forEach((child) => {

                            if (child.value.dest_domains && child.value.dest_domains.length > 0) {

                                child.value.dest_domains.forEach((domain) => {

                                    if (domain.toLowerCase().includes(self.query.toLowerCase())) {

                                        insertSource('domain', domain, 'groups_folder', group.key, group.value, 'groups', child.key, child.value)

                                    }

                                })

                            }

                        })

                    } else {
                        if (group.value.dest_domains && group.value.dest_domains.length > 0) {

                            group.value.dest_domains.forEach((domain) => {

                                if (domain.toLowerCase().includes(self.query.toLowerCase())) {

                                    insertSource('domain', domain, 'groups', group.key, group.value)

                                }

                            })

                        }
                    }


                })

            }

        },

        processSupport() {

            let self = this

            self.$parent.$refs.snackbar.showSnackbar(self.$gettext('User added successfully'))
            self.closeSupportDialog()

        },

        closeSupportDialog() {

            let self = this

            let appComponent = self.genericComponentGetComponent('App')
            appComponent.closeDialog('supportDialog')

        },
        resetForm() {
            let self = this
            self.$refs.form.reset()
            self.query = ''
        },
    },

    computed: {

        ...mapWritableState(useGroupsStore, {
            groups: 'groups',
            currentSelectedGroup: 'currentSelectedGroup',
            currentSelectedGroupName: 'currentSelectedGroupName',
        }),

        ...mapWritableState(useRulesStore, {
            rules: 'rules',
        }),

        ...mapWritableState(useUsersStore, {
            users: 'users',
        }),

        ...mapState(useConnectionsStore, {
            currentConnection: 'currentConnection',
        }),

    }
}
</script>
